<template>
    <main id="liste" v-cloak>
        <HeaderTab :title="$t('menu.congelation.production')" :swiper_tabs="swiper_tabs" />

        <div id="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <router-view></router-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>


<script type="text/javascript">
    import Navigation from "@/mixins/Navigation.js";

	export default {
		name: "CongelationProduction",
		mixins: [Navigation],
		data () {
			return {
            }
		},
        computed: {
            swiper_tabs() {
                return [{
                        id: 'statistiques_lot',
                        label: 'menu.congelation.statistiques_lot',
                        active: false,
                        href : 'CongelationStatistiquesLot'
                    },
                    {
                        id: 'statistiques',
                        label: 'menu.congelation.statistiques',
                        active: false,
                        href : 'CongelationStatistiques'
                    },
                    {
                        id: 'doses',
                        label: 'menu.congelation.doses',
                        active: false,
                        href : 'CongelationDoses'
                    },
                    {
                        id:'campagnes_non_cloturees',
                        label: 'menu.congelation.campagnes_non_cloturees',
                        active: false,
                        href: 'StallionCampagneNotClosed'
                    }
                ]
            },
        },
		components: {
            HeaderTab: () => import('@/components/HeaderTab'),
		}
	}
</script>
